// /Carrossier/FormulaireA/components/FormulaireHeader.js
import React from "react";

const FormulaireHeader = ({ produit }) => {
  return (
    <div className="bg-gradient-to-r from-orange-50 via-amber-50 to-orange-50 p-6 rounded-2xl border border-orange-200">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-12 h-12 bg-gradient-to-r from-orange-600 to-amber-600 rounded-xl flex items-center justify-center shadow-lg">
          <span className="text-white font-bold text-xl">🚪</span>
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Contrôle montage et mise en service
          </h2>
          <p className="text-gray-600">Configuration Standard - {produit?.name || "Produit Standard"}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="px-3 py-1.5 bg-orange-100 text-orange-800 rounded-full text-sm font-medium border border-orange-200">
          Configuration Standard - Roulettes FIT+ (Rouge) + Supports renforcés
        </span>
      </div>
    </div>
  );
};

export default FormulaireHeader;